import styled from 'styled-components';

const WhiteSpace = styled.div`
  min-height: ${({ size = '100px' }) => size};
`;

export default WhiteSpace;
